import React, { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import {  XMarkIcon} from "@heroicons/react/24/outline";



function SearchBox({filter,setFilter}) {
  const [value,setValue] = useState("");
  const handleClick = () =>{
    setFilter({...filter,companyName:value})
  }
  // const handleKeyDown = (event) => {
  //   // if (event.key === 'Enter') {
  //     console.log(event,"clickeddd")
  //   // }
  // };

  const handleReset = () =>{
    setFilter({...filter,companyName:""});
    setValue("");
  }

  return (
    <>
      <form>
        <div className="relative ">
          <input
            type="text"
            className="bg-gray-50 m-0 h-[40px] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-5 p-2.5  "
            placeholder="Search company name..."
            value={value}
            onChange={(e)=>setValue(e.target.value)}
            // onKeyDown={handleKeyDown}
          />
          <div className="flex">

          {(value?.length > 0) && (<button
            type="button"
            className="absolute inset-y-0 right-0 flex items-center pr-10"
            onClick={handleReset}
          >
            <XMarkIcon className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white" />
          </button>)}

          <button
            type="button"
            className="absolute inset-y-0 right-0 flex items-center pr-3"
            onClick={handleClick}
          >
            <MagnifyingGlassIcon className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white" />
          </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default SearchBox;
